<template>
    <div class="block-container">
        <div>
            <el-form>
                <el-table ref="multipleTable" :data="goodsRecvVoucherItemList" border tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column align="center" type="selection" width="55" :selectable="selectable"></el-table-column>
                    <el-table-column align="left" prop="title" label="商品名称" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="catName" label="分类" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="brandName" label="品牌" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="model" label="型号" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" label="规格" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="tmpNo" label="系统编号" width="230" show-overflow-tooltip v-if="useFor != 'assetStockIn' && assetTypes != null && assetTypes.length > 0 && assetTypes[0] != 2"></el-table-column>
                    <el-table-column align="left" prop="vendorUkno" label="商品标识码" width="220" show-overflow-tooltip v-if="useFor != 'assetStockIn' && assetTypes != null && assetTypes.length > 0 && assetTypes[0] != 2"></el-table-column>
                    <el-table-column align="right" prop="quantity" label="已收货数量" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="exchgSumQuantity" label="已换货数量" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="returnSumQuantity" label="已退货数量" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="assetInQuantity" label="已入库数量" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="assetCheckedQuantity" label="已验收数量" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="checkedQuantity" label="本次验收数量" width="100" show-overflow-tooltip v-if="useFor == 'check'">
                        <template slot-scope="scope">
                            <el-input type="text" disabled v-model="scope.row.checkedQuantity" @change="checkedQuantityChange(scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="unit" label="单位" width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="batchNo" label="批次号" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="desc" label="描述" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="assetType" label="管理方式" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="desc" label="禁用原因" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="selectable(scope.row) == false">{{ selectableMsg(scope.row) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import goodsDelivApi from '../../api/goodsDeliv'

    export default {
        name: 'swb-goods-recv-voucher-item-select',
        desc: '选择商品',
        props: ['voucherId', 'recvVoucherItemId', 'ioFlag', 'selectItems', 'devcIoDone', 'useFor', "assetTypes"], // useFor: 用途，可根据自己的情况设定值，可不传
        data: function () {
            return {
                //
                goodsRecvVoucherItemList: [],
                multipleSelection: [],
                assetTypeMap: getEnumMap("assetType", "value2text"),
            }
        },
        created: function () {
            if(this.useFor == 'check' || this.useFor == 'returnExchg') {
                this.getGoodsRecvVoucherItemRelAssets();
            } else {
                this.getGoodsRecvVoucherItems();
            }
        },
        methods: {
            selectable: function (row, index) {
                if(!Utils.isNoB(this.useFor) && this.useFor == 'assetStockIn') {
                    let quantity = row.quantity;
                    let exchgSumQuantity = row.exchgSumQuantity;
                    exchgSumQuantity = exchgSumQuantity == null ? 0 : exchgSumQuantity;
                    let returnSumQuantity = row.returnSumQuantity;
                    returnSumQuantity = returnSumQuantity == null ? 0 : returnSumQuantity;
                    quantity = quantity - exchgSumQuantity - returnSumQuantity;
                    if(quantity <= 0) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    if(this.useFor == 'check') {
                        let theBool = ((row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0)) && ((!row.setupFlag || row.setupDone) && (!row.asmblFlag || row.asmblDone) || row.assetType != 0);
                        return theBool;
                    } else if(this.useFor == 'returnExchg' || this.useFor == 'return' || this.useFor == 'exchg') {
                        let assetType = row.assetType;
                        if(assetType == 0) {
                            return (row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0);
                        } else if(assetType == 1) {
                            return (row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0);
                        } else if(assetType == 3) {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }
            },
            selectableMsg(row){
                let msg = "";
                if(!Utils.isNoB(this.useFor) && this.useFor == 'assetStockIn') {
                    let quantity = row.quantity;
                    let exchgSumQuantity = row.exchgSumQuantity;
                    exchgSumQuantity = exchgSumQuantity == null ? 0 : exchgSumQuantity;
                    let returnSumQuantity = row.returnSumQuantity;
                    returnSumQuantity = returnSumQuantity == null ? 0 : returnSumQuantity;
                    quantity = quantity - exchgSumQuantity - returnSumQuantity;
                    if(quantity <= 0) {
                        msg = msg + '可操作数量为0;';
                    }
                } else {
                    if(this.useFor == 'check') {
                        if((row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0)) {

                        } else {
                            msg = msg + '可操作数量为0;';
                        }
                        if(!row.setupFlag || row.setupDone || row.assetType != 0) {

                        } else {
                            msg = msg + '需安装未安装;';
                        }
                        if(!row.asmblFlag || row.asmblDone || row.assetType != 0) {

                        } else {
                            msg = msg + '需组装未组装;';
                        }
                    } else if(this.useFor == 'returnExchg' || this.useFor == 'return' || this.useFor == 'exchg') {
                        let assetType = row.assetType;
                        if(assetType == 0) {
                            if((row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0)) {

                            } else {
                                msg = msg + '可操作数量为0;';
                            }
                        } else if(assetType == 1) {
                            if((row.quantity || 0) - (row.returnSumQuantity || 0) - (row.exchgSumQuantity || 0) > (row.assetCheckedQuantity || 0)) {

                            } else {
                                msg = msg + '可操作数量为0;';
                            }
                        } else if(assetType == 3) {

                        }
                    } else {

                    }
                }
                return msg;
            },
            getGoodsRecvVoucherItemRelAssets: function () {
                let self = this;
                let postData = {};
                postData.voucherId = self.voucherId;
                if(!Utils.isNoB(self.recvVoucherItemId)) {
                    postData.id = self.recvVoucherItemId;
                }
                postData.useFor = self.useFor;
                postData.ioFlag = self.ioFlag;
                postData.invalid = false;
                postData.assetTypes = self.assetTypes;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherItemRelAssetList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        // self.goodsRecvVoucherItemList = result.data;
                        // 获取数量
                        self.getItemQuantityMap(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getGoodsRecvVoucherItems: function () {
                let self = this;
                let postData = {};
                postData.voucherId = self.voucherId;
                postData.ioFlag = self.ioFlag;
                postData.devcIoDone = self.devcIoDone;
                postData.invalid = false;
                postData.assetTypes = self.assetTypes;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherItemList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        // self.goodsRecvVoucherItemList = result.data;
                        // 获取数量
                        self.getItemQuantityMap(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 获取数量
            getItemQuantityMap: function (goodsRecvVoucherItemList) {
                let self = this;
//                let goodsRecvVoucherItemList = self.goodsRecvVoucherItemList || [];
                let keys = [];
                for(let i = 0; i < goodsRecvVoucherItemList.length; i++) {
                    let item = goodsRecvVoucherItemList[i];
                    let key = item.id + '_' + item.shipVoucherItemId + '_' + item.skuId;
                    if((self.useFor == 'check' || self.useFor == 'returnExchg') && item.assetType == 0) {
                        key += ('_' + item.tmpNo);
                    }
                    keys.push(key);
                }
                if(keys.length <= 0) {
                    return;
                }
                let postData = {
                    keys: keys,
                    includeCheckedInvalid: false
                };
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherItemQuantityList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        let quantityMap = result.data;
                        let exchgMap = quantityMap['exchg'] || {};
                        let returnMap = quantityMap['return'] || {};
                        let checkedMap = quantityMap['checked'] || {};
                        let assetInMap = quantityMap['assetIn'] || {};
                        for(let i = 0; i < goodsRecvVoucherItemList.length; i++) {
                            let item = goodsRecvVoucherItemList[i];
                            let key = item.id + '_' + item.shipVoucherItemId + '_' + item.skuId;
                            if((self.useFor == 'check' || self.useFor == 'returnExchg') && item.assetType == 0) {
                                key += ('_' + item.tmpNo);
                            }
                            item.exchgSumQuantity = exchgMap[key] || 0;
                            item.returnSumQuantity = returnMap[key] || 0;
                            item.assetCheckedQuantity = checkedMap[key] || 0;
                            if((self.useFor == 'check' || self.useFor == 'returnExchg') && item.assetType == 0) {
                                item.quantity = 1;
                                item.assetInQuantity = assetInMap[key] || 0;
                                item.checkedQuantity = item.quantity - item.returnSumQuantity - item.exchgSumQuantity - item.assetCheckedQuantity;
                            } else if((self.useFor == 'check' || self.useFor == 'returnExchg') && item.assetType != 0) {
                                item.checkedQuantity = item.quantity - item.returnSumQuantity - item.exchgSumQuantity - item.assetCheckedQuantity;
                            }
                        }
                        self.goodsRecvVoucherItemList = Utils.merge([], goodsRecvVoucherItemList);
                        //
                        if(!Utils.isNoB(self.goodsRecvVoucherItemList) && !Utils.isNoB(self.selectItems)) {
                            setTimeout(function () {
                                self.selectRows(self.selectItems, self.goodsRecvVoucherItemList);
                            }, 300);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectRows: function (selectRows, rows) {
                let self = this;
                if(selectRows) {
                    rows.forEach(function (row) {
                        for(let i = 0; i < selectRows.length; i++) {
                            let selRow = selectRows[i];
                            if(self.useFor == 'check' && selRow.assetType == 0) {
                                if(selRow.tmpNo == row.tmpNo) {
                                    self.$refs['multipleTable'].toggleRowSelection(row);
                                }
                            } else {
                                if(selRow.id == row.id) {
                                    self.$refs['multipleTable'].toggleRowSelection(row);
                                }
                            }
                        }
                    });
                }
            },
            // 验收数量校验
            checkedQuantityChange: function (row) {
                let checkedQuantity = row.checkedQuantity;
                if(!Utils.isNoB(checkedQuantity)) {
                    if(!Utils.isNaturalStr(checkedQuantity) || checkedQuantity <= 0) {
                        row.checkedQuantity = null;
                        MsgBox.warning("只能输入大于0的整数！");
                    } else {
                        let quantity = row.quantity || 0;
                        let assetCheckedQuantity = row.assetCheckedQuantity || 0;
                        let returnSumQuantity = row.returnSumQuantity || 0;
                        let exchgSumQuantity = row.exchgSumQuantity || 0;
                        if(parseInt(checkedQuantity) > (quantity - returnSumQuantity - exchgSumQuantity - assetCheckedQuantity)) {
                            row.checkedQuantity = null;
                            MsgBox.warning("验收数量超过了可验收数量【" + (quantity - returnSumQuantity - exchgSumQuantity - assetCheckedQuantity) + "】！");
                        }
                    }
                }
            },
            //
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let multipleSelection = self.multipleSelection;
                if(multipleSelection != null && multipleSelection.length > 0) {
                    //
                    let msg = '';
                    if(!Utils.isNoB(this.useFor) && this.useFor == 'check') {
                        for(let i = 0; i < multipleSelection.length; i++) {
                            let item = multipleSelection[i];
                            if(Utils.isNoB(item.checkedQuantity)) {
                                if(Utils.isNoB(msg)) {
                                    msg = '请输入商品【' + item.title + '】';
                                } else {
                                    msg += '、【' + item.title + '】';
                                }
                            }
                        }
                        if(!Utils.isNoB(msg)) {
                            msg += '的验收数量！';
                        }
                    }
                    //
                    if(!Utils.isNoB(msg)) {
                        result.type = 'warn';
                        result.message = msg;
                    } else {
                        //
                        result.type = 'info';
                        result.data = multipleSelection;
                    }
                } else {
                    result.type = 'warn';
                    if(self.useFor == 'returnExchg') {
                        result.message = "请至少选择一个商品！";
                    } else {
                        result.message = "请至少选择一个条目！";
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsRecvVoucherItemSelect.vue